// @module DC.CategoryCustomization.Description
define('DC.CategoryCustomization.Description.View'
,	[
	'dc_categorycustomization_description.tpl'
	,	'SC.Configuration'
	,	'DC.CategoryCustomization.Description.SS2Model'
	,	'Backbone'
	,	'underscore'
    ]
, function (
	dc_categorycustomization_description_tpl
	,	Configuration
	,	DescriptionSS2Model
	,	Backbone
	, 	_
)
{
    'use strict';

	// @class DC.CategoryCustomization.Description.View @extends Backbone.View
	return Backbone.View.extend({

		template: dc_categorycustomization_description_tpl

	,	initialize: function (options) {

			var fieldId = Configuration.get('categoryCustomization.descriptionFieldId');
			this.description = null;
			var self = this;

			if(fieldId){
				if(options.id){
					var model = new DescriptionSS2Model();
					model.fetch({
						data: {
							categoryId: options.id,
							fieldId: fieldId
						}
					}).done(function(response){
                         if(response.fields){
                            self.description = response.fields[fieldId];
                            console.log('Initial description content:', self.description);
                           
                           // Separate start tag from main content
                            var match = self.description.match(/^(<a[^>]*>\s*<img[^>]*>\s*<\/a>|<img[^>]*>)/i);

                            self.startTag = match ? match[0] : '';
                            self.mainContent = self.startTag ? self.description.replace(self.startTag, '') : self.description;

                           console.log('Start tag identified:', self.startTag);
                           console.log('Remaining main content after removing start tag:', self.mainContent);
  
                          }else {
                             console.error('No fields found in response.');
                             self.description = '';
                          }
                        self.render();
                    }).fail(function(error) {
                       console.error('Error fetching data from model:', error);
                    });
				}
			}
		}

	//	,	events: {
		//	'click [data-action="read-more-toggle"]': 'readMoreToggle'
	//	}

	, 	readMoreToggle: function(e){
		var text = this.$(e.currentTarget).html();

		if(text.toLowerCase() === 'read more'){
			this.$('.dot-span').hide();
			this.$('.more-content').show();
			this.$(e.currentTarget).html('Read less');
		}else{
			this.$(e.currentTarget).html('Read more');
			this.$('.dot-span').show();
			this.$('.more-content').hide();
		}
	}

		//@method getContext @return DC.CategoryCustomization.Description.View.Context
	, getContext: function getContext() {
        try {          
         // if(SC.CONFIGURATION.readMoreConfig.enable && this.description){
			// 	var charCount = parseInt(SC.CONFIGURATION.readMoreConfig.charCount) || 200; //default 200 character
			// 	//added 10 to check buffer before adding readmore/readless button
			// 	if(this.description.length > charCount + 10){
			// 		this.description = this.description.slice(0, charCount) + 
			// 		'<span id="dots" class="dot-span">... </span><span id="more" class="more-content" style="display:none;">' + this.description.slice(charCount) + '</span><button data-action="read-more-toggle" id="readmore" class="btn-read-more">Read more</button>';
			// 	}
			// }

			
          return {
            description: this.description
          };
        } catch (error) {
            console.error('Error in getContext function:', error);
            return { description: '' }; // Return empty to prevent rendering issues
       }
    }

  });
});
